import React from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import { useShortSelector } from 'react-redux-app/lib/modules/core/hooks';
import { useCallCancellablePromiseAndHandleErrorOrExecute } from '../../../core/api/hooks';

import {
  ALERT_TYPE__ERROR,
  ALERT_TYPE__SUCCESS,
  ALERT_TYPE__WARNING,
} from 'react-redux-app/lib/modules/alert/constants';

import { getNotifications, getDeleteNotificationError } from '../../../auth/selectors';

import { actionDeleteNotificationRequest } from '../../../auth/actions';

import { AlertsBox } from 'react-redux-app/lib/modules/alert/components';
import AlertsBoxWrapper from '../../../core/modal/components/AlertsBoxWrapper';

import styles from './styles/index.css.json';


const NOTIFICATION_TYPE__NORMAL = 'NORMAL';
const NOTIFICATION_TYPE__IMPORTANT = 'IMPORTANT';
const NOTIFICATION_TYPE__CRITICAL = 'CRITICAL';

const alertTypeMap = {
  [NOTIFICATION_TYPE__NORMAL]: ALERT_TYPE__SUCCESS,
  [NOTIFICATION_TYPE__IMPORTANT]: ALERT_TYPE__WARNING,
  [NOTIFICATION_TYPE__CRITICAL]: ALERT_TYPE__ERROR,
};

export default () => {
  const dispatch = useDispatch();

  const notifications = useShortSelector(getNotifications) || [];

  const callActionDeleteNotificationRequest = (
    useCallCancellablePromiseAndHandleErrorOrExecute(getDeleteNotificationError)
  );
  const deleteNotification = id => {
    callActionDeleteNotificationRequest(
      dispatch(actionDeleteNotificationRequest(id)),
      'header.notification.delete'
    );
  };

  return notifications.length > 0 && (
    <AlertsBoxWrapper>
      <AlertsBox
        alerts={notifications.map(({ id, message, type }) => ({
          id,
          message: (
            <div className={styles.message}>
              {message}
              <div
                className={styles.close}
                onClick={() => { deleteNotification(id); }}
              />
            </div>
          ),
          alertType: alertTypeMap[type],
          theme: { alert__text: styles.alert },
        }))}
      />
    </AlertsBoxWrapper>
  );
};
